module.exports = __webpack_public_path__ + "img/059f06a.webp";